// @flow

import Logger from "app/lib/Logger";
import EventEmitter from 'eventemitter3';

class LegacyDispatcher extends EventEmitter {
  on(events, callback) {
    return events.split(" ").map((evt) => super.on(evt, callback));
  }

  off(events, callback) {
    return events.split(" ").map((evt) => super.off(evt, callback));
  }

  emit(event, a1, a2, a3, a4, a5) {
    if (this.debug) {
      Logger.info("[Legacy Dispatcher]", ...arguments);
    }
    return super.emit(event, a1, a2, a3, a4, a5);
  }
}

export default new LegacyDispatcher();
